import { render, staticRenderFns } from "./StepNotEligibleRSVPregnancy.vue?vue&type=template&id=71f0b95a&"
import script from "./StepNotEligibleRSVPregnancy.vue?vue&type=script&lang=js&"
export * from "./StepNotEligibleRSVPregnancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports